<template>
  <div class='animated fadeIn'>
    <b-row>
      <b-col md='6'>
        <b-card>
          <div slot='header'>
            <strong><i class="fa fa-align-justify"></i> Création d'un nouveau code OAP</strong>
          </div>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="code"><strong>Code OAP : </strong></label>
            </b-col>
            <b-col sm="9">
                <b-form-input type="text" id="code" v-model="code" :class="{hasError: errors.code !== ''}"></b-form-input>
                <span class='field-error'>{{ errors.code }}</span>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="libelle"><strong>Libellé : </strong></label>
            </b-col>
            <b-col sm="9">
                <b-form-input type="text" id="libelle" v-model="libelle" :class="{hasError: errors.libelle !== ''}"></b-form-input>
                <span class='field-error'>{{ errors.libelle }}</span>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="libelleTechnique"><strong>Libellé technique : </strong></label>
            </b-col>
            <b-col sm="9">
                <b-form-input type="text" id="libelleTechnique" v-model="libelleTechnique" :class="{hasError: errors.libelleTechnique !== ''}"></b-form-input>
                <span class='field-error'>{{ errors.libelleTechnique }}</span>
            </b-col>
          </b-row>
          <!-- <b-row class="mb-1">
            <b-col sm="3">
              <label for="logo"><strong>Logo : </strong></label>
            </b-col>
            <b-col sm="9">
              <b-form-file placeholder="Sélectionner le Logo"
                           class="file-input"
                           drop-placeholder="Déposer le fichier ici..."
                           browse-text="Parcourir"
                           :state="errors.attachment !== '' ? false : null"
                           @change="addFile($event)">
              </b-form-file>
              <span class='field-error'>{{ errors.attachment }}</span>
            </b-col>
          </b-row> -->
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="structure"><strong>Structure : </strong></label>
            </b-col>
            <b-col sm="9">
              <b-form-select id="structure" v-model="selectedStructure" :options="structuresOptions" :class="{hasError: errors.structure !== ''}"></b-form-select>
              <span class='field-error'>{{ errors.structure }}</span>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="email_from"><strong>Email From : </strong></label>
            </b-col>
            <b-col sm="9">
                <b-form-input type="text" id="email_from" v-model="email_from" :class="{hasError: errors.email_from !== ''}"></b-form-input>
                <span class='field-error'>{{ errors.email_from }}</span>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="email_signature"><strong>Signature Email : </strong></label>
            </b-col>
            <b-col sm="9">
                <ckeditor :editor="editor" v-model="email_signature" :config="editorConfig"></ckeditor>
            </b-col> 
          </b-row>
          <div slot="footer">
            <b-button type="button" @click="returnBack" size="md" variant="secondary">
              <i class="fa fa-arrow-left"></i> Annuler
            </b-button>
            <b-button type="button" @click="save" size="md" class="pull-right" variant="primary">
              <i class="fa fa-save"></i> Enregistrer
            </b-button>
          </div>
        </b-card>
      </b-col>
      <b-col md='6'>
        <b-card style="height: 560px; overflow-y: hidden;">
          <h4>Liste des profils pour rattachement à l'OAP</h4>
          <VuePerfectScrollbar class="scroll-area-oap-oag" :settings="psSettings" @ps-scroll-y="scrollHandle">
            <b-form-checkbox
              class="mb-2 ml-1"
              v-model="allSelected"
              :indeterminate="indeterminate"
              aria-describedby="items"
              aria-controls="items"
              @change="toggleAll"
            >Tous sélectionner
            </b-form-checkbox>
            <b-form-group v-slot="{ ariaDescribedby }">
              <b-form-checkbox v-for="profil in allProfil"
                class="ml-1"
                v-model="selectedProfils"
                :value="profil.id"
                :aria-describedby="ariaDescribedby"
                name="profils"
                :key="profil.id"
                stacked
              >{{ profil.libelle }}</b-form-checkbox>
            </b-form-group>
          </VuePerfectScrollbar>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  import '@ckeditor/ckeditor5-build-classic/build/translations/fr';
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "@/utils/auth";
  import {isEmpty, permittedImageExtension} from "@/utils/fileHelper";
  import VuePerfectScrollbar from 'vue-perfect-scrollbar';

  export default {
    name: "Create",
    components: {
      VuePerfectScrollbar
    },
    data() {
      return {
        code: '',
        libelle: '',
        libelleTechnique: '',
        // attachment: '',
        selectedStructure: '',
        email_from: '',
        email_signature: '',
        allStructures: [],
        structuresOptions: [],
        allProfil: [],
        selectedProfils: [],
        allSelected: [],
        indeterminate: false,
        editor: ClassicEditor,
        editorConfig: {
          allowedContent: true,
          toolbar: ['heading', '|', 'bold', 'italic', '|', 'link', 'insertTable', 'tableColumn', 'tableRow', 'mergeTableCells', '|', 'indent', 'outdent', 'bulletedList', 'numberedList', 'blockQuote', '|', 'undo', 'redo'],
          language: 'fr'
        },
        errors: {
          code: '',
          libelle: '',
          libelleTechnique: '',
          // attachment: '',
          structure: '',
          email_from: '',
          email_signature: '',
        },
      }
    },
    async created() {
      this.getProfiles();
      await this.getStructures();
    },
    watch: {
      selectedProfils(newVal, oldVal) {
        // Handle changes in individual checkboxes
        if (newVal.length === 0) {
          this.indeterminate = false
          this.allSelected = false
        } else if (newVal.length === this.allProfil.length) {
          this.indeterminate = false
          this.allSelected = true
        } else {
          this.indeterminate = true
          this.allSelected = false
        }
      },
    },
    computed: {
      psSettings: () => {
        // ToDo: find better rtl fix
        return {
          maxScrollbarLength: 200,
          minScrollbarLength: 40,
          suppressScrollX: getComputedStyle(document.querySelector('html')).direction !== 'rtl',
          wheelPropagation: false,
          interceptRailY: styles => ({ ...styles, height: 0 })
        }
      }
    },
    methods: {
      scrollHandle (evt) {
        // console.log(evt)
      },
      async getStructures() {
        let self = this;
        await this.$axios
          .get("/administration/structures")
          .then(response => {
            this.allStructures = response.data.structures;
            for(let structures of response.data.structures){
              this.structuresOptions.push({value: structures.id, text: structures.libelle});
            }
          })
          .catch(() => {
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            })
          });
      },
      getProfiles() {
        this.$axios
          .get("/administration/profiles")
          .then(response => {
            this.allProfil = response.data.profils;
            // for(let profile of response.data.profiles){
            //   this.structuresOptions.push({value: structures.id, text: structures.libelle});
            // }
          })
          .catch((error) => {
            self.handleError(error);
          });
      },
      addFile(event) {
        this.attachment = event.target.files[0]
      },
      toggleAll(checked) {
        this.selectedProfils = checked ? this.allProfil.map(item => {
          return item.id
        }) : []
      },
      save() {
        if (this.validateData()) {
          this.$store.commit('IS_LOADING', true);
          let self = this;
          let code = this.code;
          let formData = new FormData();
          // formData.append('file', this.attachment);
          formData.append('code', this.code);
          formData.append('libelle', this.libelle);
          formData.append('libelleTechnique', this.libelleTechnique);
          formData.append('structure_id', this.selectedStructure);
          formData.append('email_from', this.email_from);
          formData.append('email_signature', this.email_signature);
          formData.append('profilIds', this.selectedProfils);

          this.$axios
            .post("/administration/oap", formData, {headers: {'Content-Type': 'multipart/form-data'}})
            .then(() => {
              this.$store.commit('IS_LOADING', false);
              this.$swal({
                position: 'top',
                type: 'success',
                title: 'Création avec succès',
                text: 'Le code OAP ' + code + ' a bien été créé',
                showConfirmButton: false,
                timer: 5000
              });
              this.clearFields();
              this.returnBack()
            })
            .catch((error) => {
              console.log(error)
              self.$store.commit('IS_LOADING', false);
              let text = 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI';
              if (!isEmpty(error) && error.response && error.response.status === 403) {
                text = 'Vous n\'avez pas le droit de voir ce dossier';
              } else if (!isEmpty(error) && error.response && error.response.status === 406) {
                text = error.response.data.message;
              }
              self.$swal({
                position: 'top',
                type: 'error',
                title: 'Attention !!',
                text: text,
                showConfirmButton: false,
                timer: 5000
              });
            });
        }
      },
      returnBack() {
        this.$router.push({path: '/administration/gestionOapOag/oap/list'});
      },
      validateData() {
        this.clearErrors();
        let valid = true;
        if (this.code.trim() === '') {
          this.errors.code = 'Le code est obligatoire';
          valid = false;
        }
        if (this.libelle.trim() === '') {
          this.errors.libelle = 'Le libellé est obligatoire';
          valid = false;
        }
        if (this.libelleTechnique.trim() === '') {
          this.errors.libelleTechnique = 'Le libellé technique est obligatoire';
          valid = false;
        }
        if (this.selectedStructure === '') {
          this.errors.structure = 'Le choix d\'une structure est obligatoire';
          valid = false;
        }
        // if (!isEmpty(this.attachment)) {
        //   if (!_.includes(permittedImageExtension, this.attachment.name.split('.').pop().toLowerCase())) {
        //     valid = false;
        //     this.errors.attachment = "Le Format de fichier n'est pas autorisé (formats autorisés : "+permittedImageExtension.join(', ')+")";
        //   }
        // }

        return valid;
      },
      clearErrors() {
        this.errors.code= '';
        this.errors.libelle = '';
        this.errors.libelleTechnique = '';
        this.errors.structure = '';
        // this.errors.attachment = '';
      },
      clearFields() {
        this.code = '';
        this.libelle = '';
        this.libelleTechnique = '';
        // this.attachment = '';
        this.selectedStructure = '';
        this.email_from = '';
        this.email_signature = '';
      },
    }
  }
</script>
<style type="text/css">
  .scroll-area-oap-oag {
    position: absolute;
    height: 88%;
    width: 90%;
  }
</style>
